import * as React from 'react';

import { Footer } from './components/footer';
import { Notifications } from './notifications/notifications';
import { TopBar } from './topBar';

type PageLayoutProps = {
  children?: React.ReactNode;
};

export const MainPageLayout: React.FC<PageLayoutProps> = ({ children }) => {
  return (
    <>
      <TopBar />
      <Notifications />
      {children}
      <Footer />
    </>
  );
};
